import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import { ErrorOutline } from '@material-ui/icons';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    padding: '1rem',
  },
  title: { fontSize: '1.25rem' },
});

function Title({ title }: { title: string }) {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <ErrorOutline color="error" fontSize="large" />
      <Typography className={styles.title}>{title}</Typography>
    </div>
  );
}

export default Title;
